import React from "react";
import { SITE, MAPS_EMBED_URL, MAPS_DIRECTIONS_URL } from "../lib/site-data";
import { MapPin, Navigation } from "lucide-react";

export default function Location() {
  return (
    <section
      id="location"
      className="py-20 lg:py-28 bg-white"
      data-testid="location-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-14 items-stretch">
          <div className="lg:col-span-5 flex flex-col justify-center">
            <div className="text-sm font-medium text-[#D97706] uppercase tracking-widest mb-3">
              Visit Us
            </div>
            <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl font-semibold tracking-tight text-[#0F172A] leading-tight">
              Find us in
              <br />
              <span className="text-[#1E3A8A]">Ang Mo Kio.</span>
            </h2>

            <div className="mt-7 p-6 rounded-2xl bg-[#FAFAFA] border border-[#E2E8F0]">
              <div className="flex items-start gap-4">
                <div className="w-11 h-11 rounded-2xl bg-[#1E3A8A] text-white flex items-center justify-center flex-shrink-0">
                  <MapPin className="w-5 h-5" />
                </div>
                <div>
                  <div className="text-xs uppercase tracking-widest text-[#475569] font-semibold">
                    Centre Address
                  </div>
                  <div
                    className="mt-1 font-heading text-lg text-[#0F172A] leading-snug"
                    data-testid="location-address"
                  >
                    {SITE.address.line1}
                    <br />
                    {SITE.address.line2}
                    <br />
                    {SITE.address.postal}
                  </div>
                </div>
              </div>
            </div>

            <a
              href={MAPS_DIRECTIONS_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="mt-5 inline-flex items-center justify-center gap-2 bg-[#1E3A8A] text-white hover:bg-[#1E40AF] px-6 py-3 rounded-full font-medium transition-all shadow-sm hover:shadow-md self-start"
              data-testid="location-directions-cta"
            >
              <Navigation className="w-4 h-4" />
              Get directions
            </a>

            <p className="mt-6 text-sm text-[#475569] leading-relaxed max-w-md">
              Conveniently located in Ang Mo Kio — close to bus stops and a
              short walk from Ang Mo Kio MRT.
            </p>
          </div>

          <div className="lg:col-span-7">
            <div className="rounded-3xl overflow-hidden border border-[#E2E8F0] shadow-sm h-[360px] sm:h-[420px] lg:h-full min-h-[360px] bg-[#FAFAFA]">
              <iframe
                title="The Tutor's Table location map"
                src={MAPS_EMBED_URL}
                width="100%"
                height="100%"
                style={{ border: 0 }}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
                data-testid="location-map-iframe"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
